export const GET_ACTIVITY_LOG = "GET_ACTIVITY_LOG";
export const SET_ACTIVITY_LOG = "SET_ACTIVITY_LOG";
export const GET_ACTIVITY_LOG_TO_PRINT = "GET_ACTIVITY_LOG_TO_PRINT";